import {getCurrentYear} from '../../utils/commons'
import BestDiyToolPicksLogo from './logo'
import {bestDiyToolPicksStylesUS} from './styles'

const baseConfig = {
  domainName: 'bestdiytoolpicks' as const,
  domainType: 'picks' as const,
  siteName: 'Best DIY Tool Picks',
  logo: <BestDiyToolPicksLogo className="size-10 shrink-0 tablet:size-8" />,
  favicon: '/favicons/bestdiytoolpicks.png',
  styles: bestDiyToolPicksStylesUS,
}

const localeConfigs = {
  us: {
    measurementId: 'G-XL27HBC24F',
    camelCaseUrl: 'BestDiyToolPicks.com',
    title: (category: string, count: string) =>
      `Top ${count} ${category} ${getCurrentYear()} in the US | BestDIYToolPicks.com – Reviews & Expert Insights`,
    description: (_category?: string, _count?: string) =>
      `Choose the best DIY tools with expert reviews and side-by-side comparisons. Find top-rated hand and power tools for any project with confidence.`,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
